<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<h2>
				<i class="fa fa-cubes"></i>
				Projects
			</h2>

			<projects-toolbar-controls
				v-on:searchSubmit="searchJobs"
				:show-search="showSearch"
				:show-new='true'
				:action-items="[
					{text: 'Search',icon:'fa-search'},
					{link: '/project/new/details',text: 'New Project', icon:'fa-plus'}
				]"
				:mobile-breakpoint="mobileBreakpoint"
				v-on:newClick="newJob"
				v-on:clearSearch="clearSearch"
				v-on:buttonClick="actionMenuClick">
			</projects-toolbar-controls>
		</toolbar>

		<collapsible-panel :external-toggle="filterPanelOpen" panel-size="md" v-on:panelRetract="filterPanelOpen = false">
			<template slot="panel">
				<h3>Filter Projects</h3>

				<field label="Customer"
					col-class="stacked"
					:params="{type:'select',options:$store.customerOptions}"
					v-model="filterValues.customer_id"
					v-on:change="filterValueChange">
				</field>

				<field label="Category"
					col-class="stacked"
					:params="{type:'select',options:categoryOptions}"
					v-model="filterValues.category_id"
					v-on:change="filterValueChange">
				</field>

				<field label="Revenue Code"
					col-class="stacked"
					:params="{type:'select',options:revenueCodeOptions}"
					v-model="filterValues.revenue_code_id"
					v-on:change="filterValueChange">
				</field>

			</template>

			<template slot="main">
				<table-list
					:loading="loadingProjects"
					:records="mutatedJobs"
					:fields="mutatedFields"
					:mobile-breakpoint="$store.tableListMobileBreakpoint"
					record-name="Project"
					has-edit="/project/{?}/dashboard"
					id-field="slug"
					:sortable="true"
					:clickable-row="true"
					edit-button-text="Open">

					<div class="filter-controls">
						<button class="btn btn-light mr-2" :disabled="filterPanelOpen" v-on:click="openFilterPanel">
							<i class="fa fa-filter"></i>
							Filter
						</button>

						<div class="inline-field">
							<field :params="{type:'btn-group',buttons:filterButtonsArchive,tabStyling:true}" v-model="$store.projectFilterArchiveValue" v-on:change="tabChange"></field>
						</div>

						<div v-if="$store.projectFilterArchiveValue == 'archived'" class="inline-field">
							<field :params="{type:'btn-group',buttons:filterButtonsYear,tabStyling:true}" v-model="$store.projectFilterYearValue" v-on:change="dateFilterChange"></field>
						</div>
					</div>

					<p v-if="mutatedJobs.length == 0">There are no projects found in this tab. Try going to the <router-link to="/projects/all">All</router-link> tab.</p>

				</table-list>
			</template>
		</collapsible-panel>

	</div>
</template>

<script>
import Toolbar from "../layout_fragments/Toolbar"
import TableList from "../components/TableList"
import Field from "../components/Field"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import ProjectsToolbarControls from "./project/ProjectsToolbarControls"
import JobMixins from "@/mixins/JobMixins"


export default {

	name: 'Projects',
	components: {
		Toolbar,
		TableList,
		Field,
		ProjectsToolbarControls,
		CollapsiblePanel
	},
	mixins: [JobMixins],
	data() {
		return {
			showSearch: true,
			filterValues: {
				customer_id: null,
				category: null,
				revenue_code_id: null
			},
			filterButtonsArchive: [
				{text: 'All',value:'all'},
				{text: 'Bids',value:'leads'},
				{text: 'My List',value:'relevant'},
				{text: 'Active',value:'active'},
				{text: 'Completed',value:'completed'},
				{text: 'Archived',value:'archived'},
			],
			startYear: 2018,
			filterPanelOpen: false,
			fields: [
				{
					label: "Job #",
					key: "job_num"
				},
				{
					label: "Job Name",
					key: "job_name"
				},
				{
					label: "Status",
					key: "jobStatus"
				},
				{
					label: "Category",
					key: "categoryName",
					showOnMobile: false
				},
				{
					label: "Customer",
					key: "customerCompanyName",
					showOnMobile: false
				},
				{
					label: "Date Landed",
					key: "dateLanded",
					showOnMobile: false
				}
			],
			page: 1,
			loadingProjects: true,
			mobileBreakpoint: 800
		}
	},
	computed: {
		mutatedFields() {
			let fields = JSON.parse(JSON.stringify(this.fields));

			this.$store.jobPersonnelRoles.forEach(role => {
				if (role.display_on_listings == 1) {
					fields.push({
						label: role.title,
						key: "personnelRole"+role.id,
						showOnMobile: false
					})
				}
			})

			return fields
		},
		//Filters for the quick filter buttons at top
		filteringFilters() {

			let filters = []

			//set date-based filters
			if (this.$store.projectFilterYearValue == "pre") {
				filters.push(['date_landed <',this.startYear+'-01-01'])
			}
			else if (this.$store.projectFilterYearValue != "all") {
				filters.push(['date_landed >',this.$store.projectFilterYearValue+'-01-01'])
				filters.push(['date_landed <',this.$store.projectFilterYearValue+'-12-31'])
			}

			//set status based filters
			if (this.$store.projectFilterArchiveValue == 'all')
				filters.push(['archived',0])
			else if (this.$store.projectFilterArchiveValue == 'leads') {
				filters.push(["is_lead",1])
				filters.push(["archived",0])
			}
			else if (this.$store.projectFilterArchiveValue == "active") {
				filters.push(["archived",0])
				filters.push(["is_lead",0])
				filters.push(["date_completed",null])
				filters.push(["customer_id >",0])
			}
			else if (this.$store.projectFilterArchiveValue == "completed") {
				filters.push(["archived",0])
				filters.push(["date_completed !=",null])
			}
			else if (this.$store.projectFilterArchiveValue == "archived")
				filters.push(["archived",1])

			if (this.filterValues.customer_id > 0)
				filters.push(["customer_id",this.filterValues.customer_id])

			if (this.filterValues.revenue_code_id > 0)
				filters.push(["revenue_code_id",this.filterValues.revenue_code_id])

			if (this.filterValues.category_id > 0)
				filters.push(["category_id",this.filterValues.category_id])

			return filters
		},
		filterButtonsYear() {

			let currentYear = new Date(this.moment()).getFullYear()

			let buttons = [
				{text: 'All',value: 'all'},
				{text: '< '+this.startYear,value:"pre"}
			]
			for (let y = this.startYear; y <= currentYear; y++) {
				buttons.push({text: y, value: y})
			}

			return buttons
		},
		mutatedJobs() {
			let vm = this

			if (!this.$store.projects)
				return []

			return this.$store.projects.map(job => {

				job.customerCompanyName = ""
				if (job.Customer)
					job.customerCompanyName = job.Customer.name

				job.dateLanded = job.date_landed
				if (job.date_landed == "0000-00-00")
					job.dateLanded = ""

				//figure out if any roles are displayed, and if so set the key for them

				//find user with this role and assign to the dynamic key
				if (job.JobPersonnelRole) {
					job.JobPersonnelRole.forEach(jobRole => {
						job.User.forEach(user => {
							if (jobRole.user_id == user.id)
								//assign this user to the job role key
								job["personnelRole"+jobRole.id] = user.first_name+" "+user.last_name
						})
					})
				}

				job.categoryName = ""
				if (job.Category)
					job.categoryName = job.Category.name

				job.jobStatus = this.getJobStatus(job)

				return job
			})
		}
	},
	methods: {
		openFilterPanel() {
			this.filterPanelOpen = true

			if (this.$store.customers.length == 0)
				this.fetchCustomers(true,false)

			if (this.$store.categories.length == 0)
				this.fetchJobCategories()

			if (this.$store.revenueCodes.length == 0)
				this.fetchRevenueCodes()
		},
		actionMenuClick(button) {
			if (button.text == "Search")
				this.showSearch = true
		},
		newJob() {
			this.$router.push("/project/new/details")
		},
		searchJobs(terms) {

			let vm = this

			vm.$store.projectFilterYearValue = "all";
			vm.$store.projectFilterArchiveValue = "all"

			terms = encodeURIComponent(terms)

			let filters = [
				["job_name",terms,"and","like"],
				["job_num",terms,"or","like"],
				["city",terms,"or","like"],
				["address",terms,"or","like"],
				["postal_code",terms,"or","like"],
				['customer_po',terms,'or','like']
			]

			this.fetchData(filters)
		},
		clearSearch() {
			if (this.mobileBreakpoint >= window.innerWidth)
				this.showSearch = false

			this.fetchData(this.filteringFilters)
		},
		dateFilterChange() {
			this.$store.projectFilterArchiveValue = "active"

			this.fetchData(this.filteringFilters)
		},
		tabChange() {
			window.history.pushState({},"","/projects/"+this.$store.projectFilterArchiveValue)

			this.fetchData(this.filteringFilters)
		},
		filterValueChange() {
			let vm = this

			this.$nextTick(() => {
				vm.fetchData(vm.filteringFilters)
			})
		},
		fetchData(filters) {
			let vm = this

			let includes = [
				{model: "Contact",fields:["id","slug","name"]},
				{model: "User",fields:["id","first_name","last_name","slug"]},
				{model: "JobPersonnelRole",fields:["id","user_id","display_on_listings","slug","title"]},
				{model: "Category",fields:["id","name"]},
				{model: "JobBid",fields:["id","is_active","status"]}
			]

			let promises = []

			let filtersParam = filters

			if (JSON.stringify(filters) == vm.$store.lastProjectFilters && vm.$store.lastProjectFilters != "[]" && vm.$store.lastListedProjects.length > 0) {
				//filters match the last fetch, so just pull the project list from the $store cache
				vm.$store.projects = vm.$store.lastListedProjects
				vm.loadingProjects = false

			}
			else {

				vm.$store.lastProjectFilters = JSON.stringify(filters)

				if (this.$store.projectFilterArchiveValue == "relevant") {

					//check if we have a $store cached list of relevant projects

					if (vm.$store.relevantProjects.length > 0) {
						vm.$store.projects = vm.$store.relevantProjects
					}
					else {
						let filtersUsers = [
							["User.id",this.$store.userDetails.id],
							["archived",0],
							["date_completed",null]
						]

						let params = {
							include: includes,
							filters: filtersUsers
						}

						this.spinner(true)

						this.loadingProjects = true

						promises.push(this.getJSON("JobPersonnelRole/get"))
						promises.push(this.getJSON("Job/get",params))
					}

				}
				else {
					this.spinner(true)
					this.loadingProjects = true

					let params = {
						include: includes,
						filters: filtersParam,
						//page: this.page
					}

					promises.push(this.fetchJobPersonnelRoles())
					promises.push(this.getJSON("Job/get",params))
				}

			}

			if (promises.length > 0) {
				Promise.all(promises).then(responses=>{

					vm.$store.projects = responses[1].data
					vm.$store.lastListedProjects = JSON.parse(JSON.stringify(responses[1].data))

					vm.spinner(false)
					vm.loadingProjects = false
				})
			}
		}
	},
	created() {

		if ("query" in this.$route) {
			this.filterValues = this.cloneObj(this.$route.query)
			this.openFilterPanel()
		}

		this.fetchData(this.filteringFilters)

		if (window.innerWidth > this.mobileBreakpoint)
			this.showSearch = true
		else
			this.showSearch = false

		if (this.$route.params.tab)
			this.$store.projectFilterArchiveValue = this.$route.params.tab

	}

}
</script>

<style type="text/css">
	.inline-field {
		display: inline-block;
	}

	.filter-controls {
		margin-bottom: 10px;
	}
</style>